import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'
import persistanceData from './modules/persistanceData'
import notice from './modules/notice'
import certificate from './modules/certificate'
import chatbot from './modules/chatbot'
import surgery from './modules/surgery'
import checkup from './modules/checkup'
import identity from './modules/identity'
import mobile from './modules/mobile'
import referrer from './modules/referrer'
import push from './modules/push'

const modules = {
  persistanceData,
  notice,
  certificate,
  chatbot,
  surgery,
  checkup,
  identity,
  mobile,
  referrer,
  push
}

const plugins = [
  createPersistedState({
    paths: [
      'persistanceData',
      'notice',
      'certificate',
      'chatbot',
      'surgery',
      'checkup',
      'identity',
      'mobile',
      'referrer',
      'push'
    ]
  })
]

Vue.use(Vuex)
export const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules,
  plugins
})
